import PropTypes from 'prop-types';
import React from 'react';

import { WaybillFilterQueryShape } from 'shapes/waybills';
import { gettext } from '../../utils/text';
import { FILTERS } from '../../ducks/filters';
import TableEntityFilter from '../Table/TableEntityFilter';

const WaybillMaterialFilter = ({ materialName, changeMaterialName, query }) => {
    return (
        <TableEntityFilter
            initialValue={materialName}
            onChange={changeMaterialName}
            itemsToOptions={item => ({
                text: item,
                value: item,
            })}
            name="material_filter"
            buttonPlaceholder={gettext('Select material')}
            buttonLeftIcon="tree"
            filterType={FILTERS.WAYBILL.MATERIALS}
            query={query}
        />
    );
};

WaybillMaterialFilter.propTypes = {
    materialName: PropTypes.string.isRequired,
    changeMaterialName: PropTypes.func.isRequired,
    query: WaybillFilterQueryShape.isRequired,
};

export default WaybillMaterialFilter;
